/* Shared mug wrap renderer. Kept byte-identical in theme and API. Port of final-mockups/coffee-mugs/index.html. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.MugRenderer=factory()})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict'
  // Output is a square of `size` px. UV maps are baked at 1080x1440 (the PSD space);
  // `placement` says which square of that space each view shows: x, y, side.
  const size=1080, uv={width:1080,height:1440}, psd=2000
  // The print wrap the printer expects, and the size the model draws (both edges /16).
  const wrap={width:2484,height:1146}, generated={width:2496,height:1152}
  // Slot = which part of the flat wrap a baked UV map samples, as a fraction of the wrap width.
  const slots={left:{x:0,width:.5},right:{x:.5,width:.5},center:{x:.25,width:.5}}
  const views=[
    {id:1,source:1,label:'Stacked mugs',slots:['left','right'],placement:{x:-126,y:39,side:1359}},
    {id:2,source:2,label:'Right side, in hands',slots:['right'],placement:{x:0,y:238,side:1080}},
    {id:3,source:4,label:'Left side, in hands',slots:['left'],placement:{x:-148,y:42,side:1398}},
    {id:4,source:3,label:'Size and features',slots:['right'],placement:{x:-221,y:74,side:1301},features:true},
    {id:5,source:5,label:'Left side close-up',slots:['left'],placement:{x:3,y:472,side:902}},
    {id:6,source:6,label:'Centre of the wrap',slots:['center'],placement:{x:94,y:306,side:811}},
    {id:7,source:7,label:'Right side close-up',slots:['right'],placement:{x:322,y:528,side:771}},
    {id:8,source:7,label:'Morning ritual',slots:['right'],placement:{x:322,y:528,side:771},lifestyle:{x:330,y:610,side:1300}},
  ]
  // Handle and inside colour. The print body is always white ceramic.
  const colours=[
    {name:'White',key:'white',hex:'#ffffff'},
    {name:'Black',key:'black',hex:'#141413'},
    {name:'Blue',key:'blue',hex:'#3ca3e6'},
    {name:'Green',key:'green',hex:'#b3d159'},
    {name:'Red',key:'red',hex:'#d10709'},
    {name:'Yellow',key:'yellow',hex:'#f2bf04'},
  ]
  function key(name){return String(name||'').toLowerCase().trim()}
  function find(name){return colours.find(c=>c.key===key(name))}
  function view(id){return views.find(v=>v.id===Number(id))}
  // The baked maps hold 256 coordinate steps. Smooth the coordinates (not the
  // artwork) in floating point so small lettering follows a continuous curve.
  function smoothCoordinates(raw){
    const W=uv.width,H=uv.height,kernel=[1,4,6,4,1],horizontal=new Float32Array(W*H*3),result=new Float32Array(W*H*2)
    for(let y=0;y<H;y++)for(let x=0;x<W;x++){const out=(y*W+x)*3
      for(let k=-2;k<=2;k++){const i=(y*W+Math.max(0,Math.min(W-1,x+k)))*4,weight=kernel[k+2]*raw.data[i+3]/255
        horizontal[out]+=raw.data[i]*weight;horizontal[out+1]+=raw.data[i+1]*weight;horizontal[out+2]+=weight}}
    for(let y=0;y<H;y++)for(let x=0;x<W;x++){let u=0,v=0,weight=0
      for(let k=-2;k<=2;k++){const i=(Math.max(0,Math.min(H-1,y+k))*W+x)*3;u+=kernel[k+2]*horizontal[i];v+=kernel[k+2]*horizontal[i+1];weight+=kernel[k+2]*horizontal[i+2]}
      const out=(y*W+x)*2
      // Half a coordinate step compensates for the original gradient's floor rounding.
      result[out]=weight?Math.min(255,u/weight+.5):0;result[out+1]=weight?Math.min(255,v/weight+.5):0}
    return result
  }
  function prepare(raw){return {alpha:raw.data,coords:smoothCoordinates(raw)}}
  // Where the artwork sits on the wrap: scale 1 = the whole wrap (the default);
  // translateX/Y move it by fractions of the wrap width/height. The browser
  // preview, the cart mockup and the print file all place through this.
  function fit(t){t=t||{};const scale=Math.max(.25,Math.min(1,Number(t.scale)||1)),translateX=Math.max(-.5,Math.min(.5,Number(t.translateX)||0)),translateY=Math.max(-.5,Math.min(.5,Number(t.translateY)||0));return {scale,translateX,translateY,x:.5-scale/2+translateX,y:.5-scale/2+translateY}}
  function isDefaultFit(t){const f=fit(t);return f.scale===1&&f.translateX===0&&f.translateY===0}
  // Bilinear tap of the artwork at wrap fraction (u,v) through a fit; writes the pixel at `oi`, its alpha scaled by `k`.
  function tap(art,f,u,v,out,oi,k){
    const au=(u-f.x)/f.scale,av=(v-f.y)/f.scale;if(au<0||au>1||av<0||av>1)return
    const DW=art.width,DH=art.height,fu=au*(DW-1),fv=av*(DH-1)
    const u0=Math.floor(fu),v0=Math.floor(fv),u1=Math.min(DW-1,u0+1),v1=Math.min(DH-1,v0+1),uf=fu-u0,vf=fv-v0
    const i00=(v0*DW+u0)*4,i10=(v0*DW+u1)*4,i01=(v1*DW+u0)*4,i11=(v1*DW+u1)*4
    const w00=(1-uf)*(1-vf),w10=uf*(1-vf),w01=(1-uf)*vf,w11=uf*vf
    const alpha=art.data[i00+3]*w00+art.data[i10+3]*w10+art.data[i01+3]*w01+art.data[i11+3]*w11
    if(alpha<4)return
    for(let c=0;c<3;c++)out[oi+c]=art.data[i00+c]*w00+art.data[i10+c]*w10+art.data[i01+c]*w01+art.data[i11+c]*w11
    out[oi+3]=Math.round(alpha*k)
  }
  // Warp the flat wrap through a view's UV maps. `maps` are prepared UVs in the
  // view's slot order; `art` is the whole wrap as RGBA, placed by `transform`
  // (see fit). Returns the artwork layer (RGBA, size x size) — colour
  // independent, so it is cached per view and fit.
  function artwork(v,maps,art,opacity,transform){
    const N=size,W=uv.width,H=uv.height,out=new Uint8ClampedArray(N*N*4),p=v.placement,o=opacity===undefined?1:opacity,f=fit(transform)
    for(let s=0;s<v.slots.length;s++){
      const map=maps[s],slot=slots[v.slots[s]]
      for(let py=0;py<N;py++){const y=p.y+(py+.5)*p.side/N-.5;if(y<0||y>H-1)continue
        for(let px=0;px<N;px++){const oi=(py*N+px)*4;if(out[oi+3]>0)continue // first slot to fill wins
          const x=p.x+(px+.5)*p.side/N-.5;if(x<0||x>W-1)continue
          const x0=Math.floor(x),y0=Math.floor(y),x1=Math.min(W-1,x0+1),y1=Math.min(H-1,y0+1),tx=x-x0,ty=y-y0
          const p00=(y0*W+x0)*2,p10=(y0*W+x1)*2,p01=(y1*W+x0)*2,p11=(y1*W+x1)*2
          const a=(map.alpha[p00*2+3]*(1-tx)+map.alpha[p10*2+3]*tx)*(1-ty)+(map.alpha[p01*2+3]*(1-tx)+map.alpha[p11*2+3]*tx)*ty
          if(a<12)continue
          const c=map.coords
          const uvR=(c[p00]*(1-tx)+c[p10]*tx)*(1-ty)+(c[p01]*(1-tx)+c[p11]*tx)*ty
          const uvG=(c[p00+1]*(1-tx)+c[p10+1]*tx)*(1-ty)+(c[p01+1]*(1-tx)+c[p11+1]*tx)*ty
          tap(art,f,slot.x+uvR/255*slot.width,uvG/255,out,oi,a*o/255)
        }}
    }
    return out
  }
  // The flat wrap with the artwork placed by a fit (the print file): width x height RGBA.
  function placeWrap(art,transform,width,height){
    const out=new Uint8ClampedArray(width*height*4),f=fit(transform)
    for(let y=0;y<height;y++){const v=y/(height-1);for(let x=0;x<width;x++)tap(art,f,x/(width-1),v,out,(y*width+x)*4,1)}
    return out
  }
  // Ink into ceramic: multiply the artwork over the lit base.
  function composite(base,layer){
    const out=new Uint8ClampedArray(base.data)
    for(let i=0;i<out.length;i+=4){const a=layer[i+3]/255;if(!a)continue
      for(let k=0;k<3;k++){const b=out[i+k];out[i+k]=b*(1-a)+b*layer[i+k]/255*a}}
    return out
  }
  return {size,uv,psd,wrap,generated,slots,views,colours,key,find,view,prepare,fit,isDefaultFit,artwork,placeWrap,composite}
})
